import axios from "axios"
const API_URL=process.env.REACT_APP_API_URL;

const settings={
    single(name){
        return axios.get(API_URL+"/settings.php?name="+name);
    }
    
}
export default settings;